import React, { Component } from 'react';
import ButtonPanel from '../../QbmPage/ButtonPanel';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getQuizs, setQuizItem, getQuizStatistic } from '../actions';
import classNames from 'classnames';
import moment from 'moment';
import {sortBy} from 'lodash';
import Spiner from '../../helpers/Spiner/Spiner';

class Quizs extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  render() {
    const {formatMessage} = this.context;
    const { quizs, quiz, room, loaded_quizs } = this.props;

    if(!room){
      return null;
    }

    if(!loaded_quizs){
      return <div className="qbm-accordion-component quizs">
        <div className="qbm-accordion-title">
          {formatMessage('titleClassQuizSidebar')}
        </div>
        <div className="posr qbm-accordion-body open">
          <div className="qbm-accordion-content">
            <Spiner/>
          </div>
        </div>
      </div>
    }

    return (
        <div className="qbm-accordion-component quizs">
          <div className="qbm-accordion-title">
            {formatMessage('titleClassQuizSidebar')}
          </div>
          <div className="posr qbm-accordion-body open">
            <div className="qbm-accordion-content">
              {sortBy(quizs, ['x_order']).map(item => (
                <div
                  key={`quiz-item-${item.id}`}
                  className={classNames("qbm-accordion-content__item ", {'qbm-accordion-content__item--selected': quiz && quiz.id == item.id ? true : false})}
                  onClick={() => {
                    this.props.setQuizItem(item);
                    this.props.getQuizStatistic(item.id)
                  }}
                >
                  <span className="text-ellipsis">{item.title}</span> <span className={item.active && moment() >= moment(item.active_from * 1000) && moment() <= moment(item.active_to * 1000) ? 'marker-published' : 'marker-unpublished'} />
                </div>
              ))}
            </div>
          </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  quizs: state.statistic_report.quizs,
  quiz: state.statistic_report.quiz,
  room: state.statistic_report.room,
  loaded_quizs: state.statistic_report.loaded_quizs,
})

const mapDispatchToProps = {
  setQuizItem,
  getQuizs,
  getQuizStatistic,
}

export default connect(mapStateToProps, mapDispatchToProps)(Quizs)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StatisticReports/Quizs/index.jsx